import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { editPlaceRequested } from './redux/actions';
import { getEditPlaceLoading } from './redux/selectors';
import FormInput from '../../common/FormInput';
import LocationPin from '../../icons/locationPin.svg';
import LandLocation from '../../icons/landLocation.svg';
import { TextField } from '@material-ui/core';
import { Modal } from 'react-bootstrap';
import './styles.scss';
import { noop } from '../../common/propTypes';

function EditPlaceModal({ open, handleClose, editPlace, editingPlace, place }) {
    const [projectName, setProjectName] = useState('');
    const [position, setPosition] = useState('');

    useEffect(() => {
        if (open) {
            setProjectName(place.name);
            setPosition(`${place.location.lat}, ${place.location.long}`);
        }
    }, [open]);

    useEffect(() => {
        if (!editingPlace) {
            handleClose();
        }
    }, [editingPlace]);

    return (
        <Modal
            show={open}
            onHide={noop}
            className={'create-partner-modal'}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            centered={true}
            animation={true}
        >
            {/* Modal code starts here */}
            <div className="modal-body add-places-modal">
                <div className="row">
                    <div className="col">
                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                            }}
                        >
                            <div className="row">
                                <h1>Edit Place</h1>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <FormInput
                                        title={'Name'}
                                        bootstrapIcon={LandLocation}
                                        stylesIcon={{
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <TextField
                                            type={'text'}
                                            placeholder={'Type Project Name'}
                                            onChange={(e) =>
                                                setProjectName(e.target.value)
                                            }
                                            value={projectName}
                                        />
                                    </FormInput>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-8">
                                    <FormInput
                                        title={'Location'}
                                        bootstrapIcon={LocationPin}
                                        stylesIcon={{
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <TextField
                                            type={'text'}
                                            required={true}
                                            placeholder={'Location Here'}
                                            onChange={(e) =>
                                                setPosition(e.target.value)
                                            }
                                            value={position}
                                        />
                                    </FormInput>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <button
                                        onClick={() => {
                                            if (!editingPlace) {
                                                const [
                                                    lat,
                                                    long,
                                                ] = position.split(',');
                                                editPlace(
                                                    place.id,
                                                    projectName,
                                                    lat,
                                                    long,
                                                );
                                            }
                                        }}
                                        className="btn btn-custom btn-process mt-4"
                                    >
                                        {editingPlace ? 'Saving' : 'Save'}
                                    </button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <button
                                        onClick={handleClose}
                                        className="btn btn-custom btn-reset mt-4"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Modal>
    );
}

EditPlaceModal.propTypes = {
    open: PropTypes.bool,
    handleClose: PropTypes.func,
    editPlace: PropTypes.func,
    editingPlace: PropTypes.bool,
    place: PropTypes.object,
};

EditPlaceModal.defaultProps = {
    open: false,
    handleClose: noop,
    editPlace: noop,
    editingPlace: false,
    place: {
        name: '',
        location: {},
    },
};

const mapStateToProps = (state) => {
    return {
        editingPlace: getEditPlaceLoading(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        editPlace: (placeId, name, lat, long) =>
            dispatch(editPlaceRequested({ placeId, name, lat, long })),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditPlaceModal);
